import { render, staticRenderFns } from "./Traditionista.vue?vue&type=template&id=5de23958&scoped=true&"
import script from "./Traditionista.vue?vue&type=script&lang=js&"
export * from "./Traditionista.vue?vue&type=script&lang=js&"
import style0 from "./Traditionista.vue?vue&type=style&index=0&id=5de23958&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5de23958",
  null
  
)

export default component.exports